import { render, staticRenderFns } from "./HealthWorker.vue?vue&type=template&id=32f57de8&"
import script from "./HealthWorker.vue?vue&type=script&lang=js&"
export * from "./HealthWorker.vue?vue&type=script&lang=js&"
import style0 from "./HealthWorker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports